import { render, staticRenderFns } from "./DeliveryOverview.vue?vue&type=template&id=47b06bf8&scoped=true&"
import script from "./DeliveryOverview.vue?vue&type=script&lang=js&"
export * from "./DeliveryOverview.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOverview.vue?vue&type=style&index=0&id=47b06bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b06bf8",
  null
  
)

export default component.exports